module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.3/frontend/_next/static/images/tv-border-8c1a53b6a28e79ab64767f8550222254.webp";